//lib

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import {
  AccidentFree,
  FiveDayReturn,
  GenuineMileage,
  OneSeventyPoint,
  ShieldTick,
} from "../../../assets/images";
import Container from "../../../components/element/container";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/element/icon";
import useWindowDimension from "../../../components/hook/use.window.dimension";

export default function HomeBanner() {
  const { t } = useTranslation();
  const {
  isDesktop
} = useWindowDimension();

  const dcarPointList = [
    {
      label: "Extensive Inspection",
      value: "160 point check",
      img: FiveDayReturn,
    },
    {
      label: "Transparency",
      value: "Condition Report",
      img: GenuineMileage,
    },
    {
      label: "Buyer Confidence",
      value: "Peace of mind",
      img: AccidentFree,
    },
  ];

  return (
    <Container className="home-banner">
      <Col className="_col banner-wrapper">
        <p className="_label banner-desc">{t("What is DCAR Certified ?")}</p>
        <Col className="_col banner-card">
          <Row className="_row banner-top">
            <Col className="flex-col gap-1">
              <Row className="_row certified-copy">
                <Container tag="div" className="certified-icon-wrap">
                  <Image
                    alt="Shield Tick"
                    src={ShieldTick}
                    className="_img shield-img"
                  />
                </Container>
                <Col className="_col certified-text">
                  <h4 className="_label dcar-certified">
                    <span>{t("DCAR")}</span> {t("Certified")}
                  </h4>
                  {!isDesktop && (
                    <p className="_label certified-subtext">
                      {t(
                        "Officially inspected by DCar with live verification to ensure authenticity transparency and buyer confidence",
                      )}
                    </p>
                  )}
                </Col>
              </Row>
              {isDesktop && (
                <p className="_label certified-subtext">
                  {t(
                    "Officially inspected by DCar with live verification to ensure authenticity transparency and buyer confidence",
                  )}
                </p>
              )}
            </Col>
            <Row className="_row point-badge">
              <Image
                alt="160 Point"
                src={OneSeventyPoint}
                className="_img point-value-img"
              />
              <p className="_label point-copy">
                <span>{t("Point")}</span>
                <br />
                {t("Inspection")}
                {!isDesktop ? <br /> : <> </>}
                {t("Checklist")}
              </p>
              <button type="button" className="_button banner-arrow">
                <Icon
                  icon="pepicons-pop:arrow-right"
                  className="_svg banner-arrow"
                />
              </button>
            </Row>
          </Row>
          <Row className="_row point-list">
            {dcarPointList.map((point, pointIndex) => (
              <Row key={pointIndex} className="_row point-item">
                <Icon
                  tag="span"
                  icon="cib:f-secure"
                  width={16}
                  height={16}
                  gradient
                />

                <Col className="_col point-text">
                  <p className="_label dcar-point">{t(point.label)}</p>
                  <p className="_label dcar-point-sub">{point.value}</p>
                </Col>
              </Row>
            ))}
          </Row>
        </Col>
      </Col>
    </Container>
  );
}
